// extracted by mini-css-extract-plugin
module.exports = {"hoverBgNeutral300":"menuItem_hoverBgNeutral300__mSmY7"};